import React, { useEffect, useState } from 'react';
import useParam from '../../context/ParamContext';
import { Typography } from '@mui/material';

const TooltipContent = ({ eventInfo }) => {
  const { params } = useParam();
  const [tooltipObj, setTooltipObj] = useState(null);

  useEffect(() => {
    let paramKey = 'TASKPLANNER_HINT_CONTENT';

    if (params[paramKey]) {
      const parsedObj = JSON.parse(params[paramKey]);
      setTooltipObj(parsedObj);
    }
  }, [params]);

  const task = eventInfo.event._def.extendedProps.eventData;

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (!acc) return null;
      if (Array.isArray(acc)) {
        return acc[0]?.[part];
      }
      return acc[part];
    }, obj);
  };

  const setTooltipContent = () => {
    if (!tooltipObj || !task) {
      return null;
    }

    return tooltipObj.map((item, index) => {
      const { label, fieldName } = item;
      const taskValue = getFieldValue(task, fieldName);
      if (Array.isArray(taskValue)) {
        return taskValue.map((value, subIndex) => (
          <Typography key={`${index}-${subIndex}`}>
            {label}: {value}
          </Typography>
        ));
      } else {
        return (
          <Typography key={index}>
            {label}: {taskValue}
          </Typography>
        );
      }
    });
  };

  const tooltipContent = setTooltipContent();

  return <div>{tooltipContent}</div>;
};

export default TooltipContent;
